import { render } from "./BlogDetalheView.vue?vue&type=template&id=4b1ed2d9"
import script from "./BlogDetalheView.vue?vue&type=script&lang=js"
export * from "./BlogDetalheView.vue?vue&type=script&lang=js"

import "./BlogDetalheView.vue?vue&type=style&index=0&id=4b1ed2d9&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__